export default __webpack_public_path__ + "static/media/category.f723ec27.svg";